var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAse(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7016_18986)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3 5H17C18.1046 5 19 5.89543 19 7V17C19 18.1046 18.1046 19 17 19H3C1.89543 19 1 18.1046 1 17V7C1 5.89543 1.89543 5 3 5Z",
    stroke: "#002E33",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 4C5 4.55228 5.44772 5 6 5C6.55228 5 7 4.55228 7 4H5ZM8 2H12V0H8V2ZM13 3V4H15V3H13ZM5 3V4H7V3H5ZM12 2C12.5523 2 13 2.44772 13 3H15C15 1.34315 13.6569 0 12 0V2ZM8 0C6.34315 0 5 1.34315 5 3H7C7 2.44772 7.44772 2 8 2V0Z",
    fill: "#002E33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 9L9.18772 12.639C9.70485 12.8688 10.2951 12.8688 10.8123 12.639L19 9",
    stroke: "#002E33",
    strokeWidth: 2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7016_18986"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAse);
export default __webpack_public_path__ + "static/media/сase.165c1049afb5ec7e8b4c34758c88bac2.svg";
export { ForwardRef as ReactComponent };